<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fas fa-id-badge"></i> Categoria de Atendimento</h3>
        </div>
      </div>
      <CategoriaAdd v-if="showAdd" ref="CategoriaAdd" v-on:Back="onBack" />
      <CategoriaList v-else ref="CategoriaList" v-on:New="onNew" v-on:Edit="onEdit"/>
    </div>
  </template>
<script>
import Tools from '@/components/tools/Tools.js'
import CategoriaAdd from './components/add/categoriaAdd.vue'
import CategoriaList from './components/list/categoriaList.vue'

export default {
  name: 'Categoria',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    CategoriaAdd,
    CategoriaList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.CategoriaAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/categoria/categoria.vue